import { Injector } from '@angular/core';
import { LocalStorageService } from '../shared/services/local-storage.service';

const injector = Injector.create({
    providers: [{ provide: LocalStorageService, deps: [] }]
});
export class User {
    user: any;
    userdata: any;
    localStorage: any;
    userRole: any;
    masterAdmin: any;

    constructor() {
        this.localStorage = injector.get(LocalStorageService);
        this.userdata = this.localStorage.get('userData');
    }

    public current_user() {
        return this.userdata ? this.userdata : null;
    }

    public user_state() {
        return this.userdata.customer_type.type_name
            ? this.userdata.customer_type.type_name
            : null;
    }

    public user_roles() {
        return this.userdata.role ? this.userdata.role.role : null;
    }

    public user_role_id() {
        return this.userdata.role && this.userdata.role.id
            ? this.userdata.role.id
            : null;
    }

    public user_role_name() {
        return this.userdata.role && this.userdata.role.name
            ? this.userdata.role.name
            : null;
    }

    public user_role_display_name() {
        return this.userdata.role && this.userdata.role.display_name
            ? this.userdata.role.display_name
            : null;
    }

    public user_tracking_status() {
        return this.userdata.tracking_status
            ? this.userdata.tracking_status
            : null;
    }

    public user_first_name() {
        return this.userdata.first_name ? this.userdata.first_name : null;
    }

    public user_last_name() {
        return this.userdata.last_name ? this.userdata.last_name : null;
    }

    public user_full_name() {
        return this.userdata.first_name + this.userdata.last_name
            ? this.userdata.first_name + this.userdata.last_name
            : null;
    }

    public user_id() {
        return this.userdata.user_id ? this.userdata.user_id : null;
    }

    public tenant() {
        return this.userdata.tenant ? this.userdata.tenant : null;
    }

    public tenant_state() {
        return this.userdata.tenant && this.userdata.tenant.state
            ? this.userdata.tenant.state
            : null;
    }

    public tenant_id() {
        return this.userdata.tenant && this.userdata.tenant.id
            ? this.userdata.tenant.id
            : null;
    }

    public tenant_account_type() {
        return this.userdata.account_type
            ? this.userdata.account_type.name
            : null;
    }

    public user_tenant_settings() {
        return this.userdata.tenant_setting
            ? this.userdata.tenant_setting
            : null;
    }

    public user_emailId() {
        return this.userdata.email ? this.userdata.email : null;
    }
}
